/**
 * Vista Exterior — Quote Form
 * Mobile: 3-step wizard. Desktop: single stacked form.
 */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var form = document.getElementById('VistaQuoteForm');
    if (!form) return;

    var serviceCards = form.querySelectorAll('.ve-service-select__card');
    var serviceInput = form.querySelector('[data-ve-service-input]');
    var sections = form.querySelectorAll('[data-ve-step]');
    var stepperItems = form.querySelectorAll('[data-ve-stepper] .ve-stepper__step');
    var currentStep = 1;
    var totalSteps = sections.length;

    // Service card multi-select
    serviceCards.forEach(function (card) {
      card.addEventListener('click', function () {
        card.classList.toggle('is-selected');
        var selected = form.querySelectorAll('.ve-service-select__card.is-selected');
        var values = [];
        selected.forEach(function (s) { values.push(s.getAttribute('data-service')); });
        serviceInput.value = values.join(', ');
      });
    });

    // Property Sq Ft — reveal an exact-value field when "5,000 sq. ft +" is chosen
    var sqftSelect = form.querySelector('[data-ve-sqft]');
    var sqftExactWrap = form.querySelector('[data-ve-sqft-exact]');
    var sqftExactInput = sqftExactWrap ? sqftExactWrap.querySelector('input') : null;

    function sqftNeedsExact() {
      return sqftSelect && sqftSelect.value.indexOf('5,000 sq. ft +') !== -1;
    }

    function syncSqftExact() {
      if (!sqftExactWrap || !sqftExactInput) return;
      if (sqftNeedsExact()) {
        sqftExactWrap.hidden = false;
        sqftExactInput.setAttribute('required', '');
      } else {
        sqftExactWrap.hidden = true;
        sqftExactInput.removeAttribute('required');
        sqftExactInput.value = '';
      }
    }

    if (sqftSelect) {
      sqftSelect.addEventListener('change', syncSqftExact);
      syncSqftExact();
    }

    // Visual feedback for validation errors
    function shakeElement(el) {
      if (!el) return;
      el.style.animation = 'none';
      el.offsetHeight;
      el.style.animation = 'veShake 0.4s ease';
      setTimeout(function () { el.style.animation = ''; }, 400);
    }

    var styleEl = document.createElement('style');
    styleEl.textContent = '@keyframes veShake { 0%,100%{transform:translateX(0)} 20%,60%{transform:translateX(-6px)} 40%,80%{transform:translateX(6px)} }';
    document.head.appendChild(styleEl);

    // Per-step validation (only used on mobile when navigating forward)
    function validateStep(step) {
      if (step === 1) {
        var selected = form.querySelectorAll('.ve-service-select__card.is-selected');
        if (selected.length === 0) {
          shakeElement(form.querySelector('.ve-service-select'));
          return false;
        }
        return true;
      }
      if (step === 2) {
        var ids = ['ve-address', 've-city', 've-zip'];
        for (var i = 0; i < ids.length; i++) {
          var el = form.querySelector('#' + ids[i]);
          if (el && !el.value.trim()) { el.focus(); shakeElement(el); return false; }
        }
        return true;
      }
      return true;
    }

    function goToStep(step) {
      if (step < 1 || step > totalSteps) return;
      if (step > currentStep && !validateStep(currentStep)) return;

      sections.forEach(function (el) { el.classList.remove('is-active'); });
      stepperItems.forEach(function (el, i) {
        el.classList.remove('is-active', 'is-complete');
        if (i + 1 < step) el.classList.add('is-complete');
        if (i + 1 === step) el.classList.add('is-active');
      });

      var target = form.querySelector('[data-ve-step="' + step + '"]');
      if (target) target.classList.add('is-active');

      currentStep = step;

      // Scroll to top of form on mobile
      if (window.matchMedia('(max-width: 749px)').matches) {
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    form.querySelectorAll('[data-ve-next]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToStep(currentStep + 1); });
    });
    form.querySelectorAll('[data-ve-prev]').forEach(function (btn) {
      btn.addEventListener('click', function () { goToStep(currentStep - 1); });
    });

    // Final submit — validate everything (covers both mobile and desktop paths)
    form.addEventListener('submit', function (e) {
      var selectedServices = form.querySelectorAll('.ve-service-select__card.is-selected');
      if (selectedServices.length === 0) {
        e.preventDefault();
        var sel = form.querySelector('.ve-service-select');
        shakeElement(sel);
        if (window.matchMedia('(max-width: 749px)').matches) goToStep(1);
        else sel.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      var requiredIds = ['ve-address', 've-city', 've-zip', 've-fullname', 've-email'];
      for (var i = 0; i < requiredIds.length; i++) {
        var el = form.querySelector('#' + requiredIds[i]);
        if (el && !el.value.trim()) {
          e.preventDefault();
          // On mobile, jump to the step that contains the missing field
          if (window.matchMedia('(max-width: 749px)').matches) {
            var section = el.closest('[data-ve-step]');
            if (section) goToStep(parseInt(section.getAttribute('data-ve-step'), 10));
          }
          el.focus();
          shakeElement(el);
          return;
        }
      }

      // If "5,000 sq. ft +" is selected, the exact value is required
      if (sqftNeedsExact() && sqftExactInput && !sqftExactInput.value.trim()) {
        e.preventDefault();
        if (window.matchMedia('(max-width: 749px)').matches) {
          var sqftSection = sqftExactInput.closest('[data-ve-step]');
          if (sqftSection) goToStep(parseInt(sqftSection.getAttribute('data-ve-step'), 10));
        }
        sqftExactInput.focus();
        shakeElement(sqftExactInput);
        return;
      }

      // Build the contact email body
      function getVal(id, fallback) {
        var el = form.querySelector('#' + id);
        return (el && el.value && el.value.trim()) ? el.value.trim() : (fallback || 'Not provided');
      }

      var service = serviceInput.value || 'Not specified';
      var address = getVal('ve-address');
      var city = getVal('ve-city');
      var state = getVal('ve-state');
      var zip = getVal('ve-zip');
      var propType = getVal('ve-property-type');
      var stories = getVal('ve-story-count');
      var sqft = getVal('ve-sqft');
      if (sqftNeedsExact() && sqftExactInput && sqftExactInput.value.trim()) {
        sqft = sqftExactInput.value.trim() + ' sq. ft (exact)';
      }
      var phone = getVal('ve-phone');
      var notes = getVal('ve-notes', 'None');
      var smsConsent = form.querySelector('#ve-sms-consent');
      var smsLine = (smsConsent && smsConsent.checked) ? 'Yes (opted in)' : 'No';

      var body = form.querySelector('#ve-notes');
      body.value =
        'SERVICE(S): ' + service + '\n' +
        'ADDRESS: ' + address + ', ' + city + ', ' + state + ' ' + zip + '\n' +
        'PROPERTY: ' + propType + ', ' + stories + ', ' + sqft + '\n' +
        'PHONE: ' + phone + '\n' +
        'SMS CONSENT: ' + smsLine + '\n' +
        'NOTES: ' + notes;
    });
  });
})();
